import { query, request } from '@/utils/request';

const urls = {
  // permission: '/zlb/api/sop/content/permission', // 权限获取
  submitted: '/api/workbench/my/submitted_bill', // 我的单据
  receive: '/api/workbench/my/receive_bill', // 我的审批
  confirmInfo: '/api/workbench/my/confirm_info/get', // 信息确认
  submitConfirmInfo: '/api/workbench/confirm_info/submit', // 个人信息确认完善提交
  content: '/zlb/api/sop/content/workbench', // 工作台查询
  articleList: '/zlb/api/sop/org/article/work-beach', // 工作台文章查询
  detail: '/zlb/api/sop/article', // 详情
  authority: '/zlb/api/sop/common/authority', // 查询用户的业务查看权限

  // 自建版本
  myform: '/zlb/api/expense/common/my-form', // 我的单据
  myapproval: '/zlb/api/expense/common/my-approval', // 我的审批
  bankList: '/zlb/api/pay/bankCard/bank/list', // 银行列表
  submitCardInfo: '/zlb/api/pay/bankCard/add', // 添加银行卡信息
  completePassword: '/api/user/supplement/password', // 第一次登录app密码为空完善密码
  needCompletePassword: '/api/workbench/my/confirm_info/get', // 是否需要完善密码
  needCompleteBankInfo: '/zlb/api/pay/bankCard/need-add-account',
  activation: '/api/user/sure/activation', // 获取激活信息
  boundOfficial: '/zlb/api/pay/bankCard/official/bound', // 已绑定的公务卡
  divisionRanking: '/zlb/api/sop/statistics/district/rank',
  onlineRankDetail: '/zlb/api/sop/statistics/district/online/rank/detail',
  activeRankDetail: '/zlb/api/sop/statistics/district/active/rank/detail',
  institutionAdmin: '/api/zlbuser/config/position/institution/admin', // 获取单位管理岗id,
  /**
   * 获取自己可见的 Banner 列表，首页使用
   */
  getOperatorBannerList: '/api/workbench/banner/list',
};

export async function getOperatorBannerList(params) {
  return request(urls.getOperatorBannerList, { params });
}

export async function reqLayout(params) {
  return request(urls.layout, { params });
}

export async function reqSubmittedList(params) {
  return request(urls.submitted, { params });
}

export async function reqReceiveList(params) {
  return request(urls.receive, { params });
}

export async function reqConfirmInfo(params) {
  return request(urls.confirmInfo, { params });
}

export async function reqSubmitConfirmInfo(data) {
  return request(urls.submitConfirmInfo, { method: 'POST', data });
}

export async function reqContent(data) {
  return request(urls.content, { method: 'POST', data });
}

export async function reqArticleList(params) {
  return request(urls.articleList, { params });
}

export async function reqDetail(params) {
  return request(`${urls.detail}/${params.contentCode}`);
}

export async function reqAuthority() {
  return request(urls.authority);
}

// export async function reqMyForm () {
//   return request(urls.myform);
// }

export async function reqMyForm(data) {
  return request('/zlb/api/search/page/web/form', { method: 'POST', data });
}

// export async function reqMyApproval () {
//   return request(urls.myapproval);
// }

export async function reqMyApproval(data) {
  return request('/zlb/api/search/page/web/form-audit', { method: 'POST', data });
}

export async function reqBankList(params) {
  return request(urls.bankList, {
    params,
  });
}

export async function reqSubmitCardInfo(data) {
  return request(urls.submitCardInfo, { method: 'POST', data });
}

export async function reqCompletePassword(data) {
  return request(urls.completePassword, { method: 'POST', data });
}

export async function reqNeedCompletePassword(params) {
  return request(urls.needCompletePassword, {
    params,
  });
}

export async function reqNeedCompleteBankInfo(params) {
  return request(urls.needCompleteBankInfo, {
    params,
  });
}
// 获取激活信息
export async function reqActivation(params) {
  return request(urls.activation, {
    params,
  });
}
// 获取已绑定的银行卡
export async function getBoundOfficialCard(params) {
  return request(urls.boundOfficial, {
    params,
  });
}

// 获取区划排行
export async function getDivisionRanking() {
  return request(urls.divisionRanking);
}

// 获取区划上线排行详情
export async function getOnlineRankDetail() {
  return request(urls.onlineRankDetail);
}

// 获取区划活跃排行详情
export async function getActiveRankDetail() {
  return request(urls.activeRankDetail);
}

// 公告
export async function getNotice(params) {
  return request('/zlb/api/sop/notice/showNotice', {
    params,
  });
}

// 公告通知确认已阅
export async function readNotice(params) {
  return request(`/zlb/api/sop/notice/confirmRead/${params}`, { method: 'POST' });
}

// 流程信息查询
export async function beginnerProcess() {
  return request('/zlb/api/sop/beginner/process-info');
}

// 页面信息查询
export async function getPageInfo(params) {
  return request('/zlb/api/sop/beginner/page-info', { params });
}

// 获取性别枚举集合
export async function getGendertype() {
  return request('/api/user/dictionary/gendertype');
}

// 下一步操作
export async function nextStep(data) {
  return request('/zlb/api/sop/beginner/next-step', { method: 'POST', data });
}

// 获取当前用户新被邀请的身份列表
export async function checkInvites(params) {
  return request('/api/user/operator/invites', {
    params,
  });
}

// 获取单位管理岗id
export async function reqInstitutionAdmin() {
  return request(urls.institutionAdmin);
}

// 获取验证码
export async function getMobileCode(data) {
  return request('/api/user/send/mobile/code', { method: 'POST', data });
}

// 修改新手机号保存接口
export async function completeMobile(data) {
  return request('/api/user/new/mobile', { method: 'POST', data });
}

// 获取机构需要提示的任务
export async function getInstitutionTask(params) {
  return query('/api/zlbuser/institution/task', { params });
}
